import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getDesignationsLevel } from "../../actions/userActions/designationLevelAction";
import DynamicTable from "../reuse_components/DynamicTable";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddDesignationLevel from "./AddDesignationLevel";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

import thIcon from "../../assets/images/thIcon.svg";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import { t } from "../../locales/translate";
function DesignationLevel() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [DesignationLevelData, setDesignationLevelData] = useState([]);
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const designationLevels = useSelector(
    (state) => state.designationLevels_reducer.designationLevels
  );

  const isLoading = useSelector((state) => state.designationLevels_reducer.isDesignationLevelLoading);

  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  useEffect(() => {
    dispatch(getDesignationsLevel(currentPage, itemsPerPage, searchQuery));
  }, [dispatch, currentPage, searchQuery]);

  useEffect(() => {
    const designationLevelData =
      designationLevels?.result?.map((level) => ({
        ...level,
        status: (
          <span className={level.active ? "status-badge-active" : "status-badge-inactive"}>
            {level.active === true || level.active === 1 ? "Active" : "Inactive"}
          </span>
        ),
      })) || [];
  
    setDesignationLevelData(designationLevelData);
  }, [designationLevels]);
  

  const totalPages = designationLevels?.totalPages || 0;
  const totalItems = designationLevels?.totalCount || 0;

  const columns = [
    { label: `${t("levelOrder")}`, accessor: "id" },
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    { label: `${t("status")}`, accessor: "status" },
  ];

  const handleAddClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditDesignationLevel = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getDesignationsLevel(pageNumber, value, searchQuery));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async (newData) => {
    dispatch(getDesignationsLevel(currentPage, itemsPerPage, searchQuery));
    setShowModal(false);
  };
 
 const actions = [
    {
      label: "Edit DesignationLevel",
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: "CanUpdateDesignationLevel",
      handler: handleEditDesignationLevel,
    },
  ];

  return (
    <div>
      <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
      <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ minWidth: '80px', marginRight: '10px' }}>
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
              {permissions?.includes("CanAddDesignationLevel") && (
                <CustomButton
                  text={t("addNew")}
                  onClick={handleAddClick}
                />
              )}
            </div>
          </div>
       
        </div>
        <DynamicTable
            data={DesignationLevelData}
            columns={columns}
            permissions={permissions}
            actions={actions}
            thIcon={thIcon}
            showPagination={totalItems > 0}
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
         
      </div>

      {showModal && (
        <AddDesignationLevel
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
    </div>
  );
}

export default DesignationLevel;
